export default __webpack_public_path__ + "static/archive-f3dc9309cde9f100969725a1eb66fbf9.jpg";